import React, { useCallback, useMemo, useState } from "react";
import classNames from "classnames";
import { Field, useForm } from "react-final-form";
import { useSelector } from "react-redux";
import Input from "rs-components/Input";
import SelectInput from "rs-components/Input/components/SelectInput";
import SelectItemRenderer from "rs-components/Input/components/SelectInput/components/SelectItemRenderer";
import RangeDialog, { FormFields } from "../../../../../RangeDialog";
import ParameterValues from "../../../../../ParameterValues";
import TextTruncate from "components/TextTruncate";
import { findDictionaryItemByValue, resultElementParameterType } from "shared/rsDictionary";
import { ResultElementParameterType, } from "store/rs-workspace/rs-workspace.types";
import { getAlternativeStepParameterInitialValues } from "store/rs-workspace/selectors/results.selectors";
import { ParameterFields } from "../../../../types";
import { MIN_FLOWS_QUANTITY } from "store/rs-workspace/utils/common.utils";
import { ALTERNATIVE_FLOW_SELECTION_INSTRUCTION } from "shared/labels";
import * as styles from "../../../../styles.module.scss";
const AlternativeStepFields = ({ name, parameter, sources, restrictions }) => {
    const form = useForm();
    const flows = useSelector(getAlternativeStepParameterInitialValues(parameter.parameter));
    const [rangeDialogOpen, setRangeDialogOpen] = useState(false);
    const flowsLabel = useMemo(() => {
        const flowIndexes = form.getFieldState(`${name}.${ParameterFields.parameter}.${ParameterFields.flowIndexes}`)?.value || [];
        return flows?.flowsList.filter((_, index) => flowIndexes.includes(index)).join(" + ");
    }, [flows?.flowsList, form, name]);
    const onFlowsSelectionSubmit = useCallback((values) => {
        const flowIndexes = values?.[FormFields.flowIndexes];
        form.change(`${name}.${ParameterFields.parameter}.${ParameterFields.flowIndexes}`, flowIndexes ? [...(flowIndexes ?? [])].sort() : undefined);
        setRangeDialogOpen(false);
    }, [form, name]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(styles.cell, styles.type) },
            React.createElement(Field, { name: `${name}.${ParameterFields.type}`, component: "input", type: "hidden" }),
            React.createElement(TextTruncate, { text: findDictionaryItemByValue(resultElementParameterType, ResultElementParameterType.RECIPE)?.label.replace(" parameter", ""), className: styles["preview-value"] })),
        React.createElement("div", { className: classNames(styles.cell, styles.value) },
            React.createElement(ParameterValues, { parameter: parameter, sources: sources })),
        React.createElement("div", { className: classNames(styles.cell, styles.unit) }),
        React.createElement("div", { className: classNames(styles.cell, styles.range) },
            React.createElement(Input, { name: `${name}.${ParameterFields.parameter}.${ParameterFields.flowIndexes}`, component: SelectInput, autoFocus: true, items: [
                    {
                        value: flowsLabel,
                        label: flowsLabel,
                    },
                ], value: flowsLabel, placeholder: "Select", itemRenderer: SelectItemRenderer, popoverProps: {
                    onInteraction: () => setRangeDialogOpen(true),
                }, classes: {
                    container: styles.selectWrapper,
                    component: styles.select,
                }, restrictions: { ...restrictions?.FlowIndexes, IsNecessary: true }, externalError: (form.getFieldState(`${name}.${ParameterFields.parameter}.${ParameterFields.flowIndexes}`)
                    ?.value || []).length < MIN_FLOWS_QUANTITY
                    ? ALTERNATIVE_FLOW_SELECTION_INSTRUCTION
                    : undefined }),
            rangeDialogOpen && (React.createElement(RangeDialog, { title: parameter.parameter?.name ?? "", flows: flows, onSubmit: onFlowsSelectionSubmit, onClose: () => setRangeDialogOpen(false) }))),
        React.createElement("div", { className: classNames(styles.cell, styles.granularity) })));
};
export default AlternativeStepFields;
